import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface ILinkProps {
  text: string;
  href?: string;
  onClick?: () => void;
}

export const HelpMenuLink = ({ text, href, onClick }: ILinkProps) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    onClick?.();
    if (href) {
      navigate(href);
    }
  };

  return (
    <button
      type="button"
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        width: 'fit-content',
      }}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Text color={isHovered ? Colors.neutral_300 : Colors.neutral_600} fontSize={18} bold>
        {text}
      </Text>
    </button>
  );
};
